import { render } from "./virtualRegion.vue?vue&type=template&id=6b281cce&scoped=true"
import script from "./virtualRegion.vue?vue&type=script&lang=js"
export * from "./virtualRegion.vue?vue&type=script&lang=js"

import "./virtualRegion.vue?vue&type=style&index=0&id=6b281cce&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b281cce"]])

export default __exports__